import { Stack, Text, ThemeIcon } from "@mantine/core";
import { IconBell } from "@tabler/icons-react";
import { NotificationTab } from "../../../../config";

interface NotificationEmptyStateProps {
  activeTab: NotificationTab;
}

export function NotificationEmptyState({ activeTab }: NotificationEmptyStateProps) {
  return (
    <Stack align="center" py="xl" gap="xs">
      <ThemeIcon size={48} variant="light" color="gray" radius="xl">
        <IconBell size={24} />
      </ThemeIcon>
      <Text size="sm" c="dimmed">
        {activeTab === "unread" ? "Không có thông báo chưa đọc" : "Chưa có thông báo"}
      </Text>
    </Stack>
  );
}
